import React, { useEffect, useState } from 'react';
import { Authenticator, useAuthenticator, View, Image, Heading, useTheme } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import './custom-styles.css'; // Importa tu archivo CSS personalizado
import logo from '../media/Logo-Ressolve.png';
import ForgotPasswordFlow from './ResetPassword';

const components = {
  Header() {
    const { tokens } = useTheme();
    return (
      <View className="logo" textAlign="center" padding={tokens.space.large}>
        <Image alt="Ressolve logo" src={logo} />
      </View>
    );
  },
  SignIn: {
    Header() {
      const { tokens } = useTheme();
      return (
        <Heading padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`} level={3}>
          Ingresa a tu cuenta
        </Heading>
      );
    },
    Footer({ switchToForgotPassword }) {
      const { toForgotPassword } = useAuthenticator();
      return (
        <div style={{ textAlign: 'center', marginTop: '-30px' }}>
          <button
            style={{
              backgroundColor: 'transparent',
              color: '#000000',
              border: 'none',
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
            onClick={toForgotPassword}
          >
            ¿Olvidó su contraseña?
          </button>
        </div>
      );
    },
  },
};

const formFields = {
  signIn: {
    username: {
      placeholder: 'Ingresa tu usuario',
    },
    password: {
      placeholder: 'Ingresa tu contraseña',
    },
  },
};

export function CustomAuthenticator({ children }) {
  const [isForgotPassword, setIsForgotPassword] = useState(false);

  useEffect(() => {
    document.body.classList.add('login-page');
    return () => {
      document.body.classList.remove('login-page');
    };
  }, []);

  // Alterna entre inicio de sesión y recuperación de contraseña
  const switchToForgotPassword = () => setIsForgotPassword(true);
  const switchToSignIn = () => setIsForgotPassword(false);

  return (
    <div className="login-container">
      {isForgotPassword ? (
        <ForgotPasswordFlow switchToSignIn={switchToSignIn} />
      ) : (
        <Authenticator
          loginMechanisms={['username']}
          hideSignUp={true}
          formFields={formFields}
          components={{
            ...components,
            SignIn: {
              ...components.SignIn,
              Footer: () => components.SignIn.Footer({ switchToForgotPassword }),
            },
          }}
        >
          {children}
        </Authenticator>
      )}
    </div>
  );
}
